<template>
    <welcome></welcome>
</template>

<script>
// @ is an alias to /src
import Welcome from "../components/Welcome";

export default {
  name: 'home',
  components: {
    Welcome
  }
}
</script>

<style>
  .full-width {
    width: 100%;
  }
</style>
